let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1Ll72")).then(() => parcelRequire('1qIfR'));